export default {
  vanDatetimePicker: {
    confirm: "Close11",
    cancel: "Cancel",
  },
  name: "Name",
  tel: "Phone",
  save: "Save",
  confirm: "Confirm",
  cancel: "Cancel",
  delete: "Delete",
  complete: "Complete",
  loading: "Loading...",
  telEmpty: "Please fill in the tel",
  nameEmpty: "Please fill in the name",
  nameInvalid: "Malformed name",
  confirmDelete: "Are you sure you want to delete?",
  telInvalid: "Malformed phone number",
  SelectYearMonthDay: "Select Year, Month, Day",
  vanCalendar: {
    end: "End",
    start: "Start",
    title: "Calendar",
    confirm: "Confirm",
    startEnd: "Start/End",
    weekdays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    monthTitle: (year, month) => `${year}/${month}`,
    rangePrompt: (maxRange) => `Choose no more than ${maxRange} days`,
  },
  vanCascader: {
    select: "Select",
  },
  vanContactCard: {
    addText: "Add contact info",
  },
  vanContactList: {
    addText: "Add new contact",
  },
  vanPagination: {
    prev: "Previous",
    next: "Next",
  },
  vanPullRefresh: {
    pulling: "Pull to refresh...",
    loosing: "Loose to refresh...",
  },
  vanSubmitBar: {
    label: "Total：",
  },
  vanCoupon: {
    unlimited: "Unlimited",
    discount: (discount) => `${discount * 10}% off`,
    condition: (condition) => `At least ${condition}`,
  },
  vanCouponCell: {
    title: "Coupon",
    tips: "No coupons",
    count: (count) => `You have ${count} coupons`,
  },
  vanCouponList: {
    empty: "No coupons",
    exchange: "Exchange",
    close: "Close",
    enable: "Available",
    disabled: "Unavailable",
    placeholder: "Coupon code",
  },
  vanAddressEdit: {
    area: "Area",
    postal: "Postal",
    areaEmpty: "Please select a receiving area",
    addressEmpty: "Address can not be empty",
    postalEmpty: "Wrong postal code",
    defaultAddress: "Set as the default address",
    telPlaceholder: "Phone",
    namePlaceholder: "Name",
    areaPlaceholder: "Area",
  },
  vanAddressEditDetail: {
    label: "Address",
    placeholder: "Address",
  },
  vanAddressList: {
    add: "Add new address",
  },
  realName: "real name",

  unionManagement: {
    GuildRegistration: "Guild Registration",
    ApplicantID: "Applicant ID",
    GuildName: "Guild Name",
    PleaseGuildName: "Please enter the guild name",
    PleaseGuildID: "Please enter the Guild ID",
    PleaseInformation: "Please enter your contact information",
    PlatformsWith: "Platforms you have worked with",
    ListOfplatforms: "List the platforms you have worked with",
    GuildSize: "Guild Size",
    EstimatedNumber: "Estimated number of guild hosts",
    Notes:
      "Note: You can contact the guild leader or guild members to obtain the guild ID.",
    Submit: "Submit",
    SubmitSuccess: "Submitted successfully",
    MyGuild: "My Guild",
    VoiceHallOnboarding: "Voice Hall Onboarding",
    VoiceHallName: "Voice Hall Name",
    PleaseVoiceHallName: "Please enter Voice Hall Name",
    WhatsApp: "WhatsApp",
    PleaseContactInfo: "Please enter your contact information",
    PlatformsCollaborated: "Platforms collaborated with",
    ListPlatformsCollaborated: "List platforms collaborated with",
    VoiceHallScale: "Voice Hall Scale",
    EstimatedAnchors: "Estimated number of Voice Hall anchors",
    CertificationType: "Certification Type",
    VoiceHall: "Voice Hall",
    VoiceGuild: "Voice Guild",
    HostName: "Host Name",
    GuildJoinDate: "Guild Join Date",
    TotalMembers: "Total Number of Guild Members",
    TotalPeople: "Total Number of People",
    DataDetails: "Data Details",
    PleaseHostID: "Please enter the host ID",
    Search: "Search",
    KickOut: "Kick Out",
    NoData: "No data available",

    InformationData: "Information Data",
    Name: "Name",
    PleaseID: "Please ensure it matches the name on your ID.",
    IdentityCard: "Identity Card",
    YourIDnumber: "Your ID number",
    IDPhoto: "ID Photo",
    PleasePhoto: "Please upload your ID photo.",
    FrontofID: "Front of ID",
    BackofID: "Back of ID",
    NotePlease:
      "Note: Please upload a photo of yourself holding the ID. Your face must be clear and unobstructed, and the ID photo and number must be legible.",
    Country: "Country",
    SelectCountryorRegion: "Select Country/Region",
    BankName: "Bank Name",
    Pleasebankname:
      "Please enter the name of the bank where your account is held.",
    BankCardNumber: "Bank Card Number",
    Pleasebankcardnumber: "Please enter your bank card number.",
    BankCardHolder: "Bank Card Holder",
    Pleasebankcardholder: "Please enter the name of the bank card holder.",
    PhoneNumber: "Phone Number",
    Enterphonenumber: "Enter a valid phone number.",
    Notebankaccount:
      "Note: Please enter the phone number linked to your bank account.",
    WhatsAppContactInformation: "WhatsApp Contact Information",
    Pleaseownnumber: "Please ensure you enter your own phone number.",
    Notecollaborationmatters:
      "Note: The WhatsApp contact provided by the guild will be considered the sole contact for collaboration matters.",
    Email: "Email",
    Pleaseemailaddress: "Please ensure you enter your own email address.",
    Notematters:
      "Note: The email provided by the guild will be considered the sole contact for collaboration matters.",

    SpecialGiftDetails: "Special Effect Gift Details",

    CurrentDate: "Current Date",
    GoldCoinTransactions: "Gold Bean Lucky Earnings",
    LiveStreamingDuration: "Live Streaming Duration",
    GoldBeanEarnings: "Gold Bean Earnings",
    EffectiveDays: "Effective Days",
    WarningCount: "Warning Count",
    give: "give",

    pleasewait: "Request in progress, please wait...",

    JoinGuild: "Join Guild",
    GuildId: "Guild ID",
    PlaceholderGuildId: "Please Enter Guild ID",

    InvitationCode: "Invitation code",

    noMore: "No more",

    Recommendation: "Recommendation (Optional)",
    nightLiveTime: "Specific time",

    // Guild Data Page
    GuildIncome: "Guild Income",
    AnchorIncome: "Anchor Income",
    EffectiveLive: "Effective Live",
    EffectiveDays: "Effective Days",
    Income: "Income",
    Duration: "Duration",
  },

  anchorCenter: {
    todayLiveData: "Today's Live Data",
    time: "Time",
    duration: "Duration",
    income: "Lucky Gold Bean Earnings",
    giftRecord: "Gift Record",
    withdraw: "Withdraw",
    tipsUpdate: "Note: Daily data is updated every minute",
    overallData: "Overall Data",
    totalDays: "Total Days",
    totalDuration: "Total Duration",
    totalTurnover: "Total Lucky Gold Beans",
    totalIncome: "Total Basic Salary",
    totalBeans: "Total Beans",
    dataListMonth: "Data List [{month}]",
    filter: "Filter",
    date: "Date",
    turnover: "Turnover",
    beans: "Beans",
    luckyBeans: "Lucky Beans",
    specialBeans: "Special Beans",
    baseSalary: "Base Salary",
    totalIncomeLabel: "Total Beans",
    zeroTime: "0h 0m",
    year: "",
    month: "",
  },

  familyMain: {
    anchorList: "Anchor List",
    anchorData: "Anchor Data",
    micTime: "Mic Time",
    micTimeData: "Mic Time Data",
    beansDetail: "Beans Detail",
    beansDetailData: "Beans Detail Data",
    withdrawDetail: "Withdraw Detail",
    withdrawDetailData: "Withdraw Detail Data",
    roomData: "Room Data",
    roomDataData: "Room Data Data",
    distributeBeans: "Distribute Beans",
    distributeBeansData: "Distribute Beans Data",
    privateShareStats: "Private/Share Stats",
    privateShareStatsData: "Private/Share Stats Data",
    roomTurnover: "Room Turnover",
    roomTurnoverData: "Room Turnover Data",
    incomeRecord: "Income Record",
    incomeRecordData: "Income Record Data",
    knapsackGiftDetail: "Knapsack Gift Detail",
    knapsackGiftData: "Knapsack Gift Data",
    roomFilterTitle: "Room Filter",
    roomFilterConfirm: "Done",
    allRooms: "All rooms",
  },
  anchorList: {
    countLabel: "【{count} anchors】",
    searchPlaceholder: "Enter anchor ID",
    search: "Search",
    joinTimeLabel: "Join time: ",
    noData: "No data",
    nickNameFallback: "Anchor nickname",
    invalidUserId: "Please enter a numeric ID",
  },

  salaryMain: {
    searchPlaceholder: "Enter anchor ID to search",
    dateSelect: "Date",
    byDay: "By Day",
    byRange: "By Range",
    searchTime: "Search Time",
    to: " to ",
    dataSummary: "Data Summary",
    totalMicTime: "Total Mic Time",
    totalHeartGiftTurnover: "Total Lucky Gold Beans",
    totalLuxuryGiftTurnover: "Total Gold Beans",
    member: "Members",
    anchorProfile: "Anchor Profile",
    micTime: "Mic Time",
    heartGiftTurnover: "Lucky Gold Beans",
    luxuryGiftTurnover: "Total Gold Beans",
    roomNumber: "Room number",
    pleaseSelectTime: "Select time",
    pleaseEnterNumber: "Please enter a number",
    selectAll: "All",
    minute: "m",
    second: "s",
  },

  micTime: {
    searchPlaceholder: "Enter anchor ID",
    search: "Search",
    dateSelect: "Date",
    today: "Today",
    thisWeek: "This Week",
    lastWeek: "Last Week",
    totalMicTime: "Total Mic Time",
    date: "Date",
    anchorInfo: "Anchor Info",
    micTime: "Mic Time",
    pleaseSelectTime: "Select time",
    selectAll: "All",
    minute: "m",
    second: "s",
  },

  anchroOtayonii: {
    dateSelect: "Date",
    byDay: "By Day",
    byRange: "By Range",
    searchTime: "Search Time",
    to: " to ",
    dataSummary: "Data Summary",
    totalLuckyGift: "Total Lucky Gift",
    totalSpecialGift: "Total Special Gift",
    totalKnapsackGift: "Total Knapsack Gift",
    anchorInfo: "Anchor Info",
    luckyGift: "Lucky Gift",
    specialGift: "Special Gift",
    knapsackGift: "Knapsack Gift",
    pleaseSelectTime: "Select time",
    selectAll: "All",
  },

  roomCm: {
    dateSelect: "Date",
    today: "Today",
    thisWeek: "This Week",
    lastWeek: "Last Week",
    dataSummary: "Data Summary",
    totalTurnover: "Total Lucky Gold Beans",
    totalTurnoverBeans: "Total Gold Beans",
    date: "Date",
    heartGiftTurnover: "Lucky Gold Beans",
    specialGiftTurnover: "Total Turnover Gold Beans",
    room: "Room",
    pleaseSelectTime: "Select time",
    selectAll: "All",
    minute: "m",
    second: "s",
  },

  weekProfit: {
    dateSelect: "Date",
    time: "Time",
    type: "Type",
    beans: "Beans",
    pleaseSelectTime: "Select time",
  },

  //提现记录
  withdrawRecord: {
    withdrawAmount: "withdraw amount",
    withdrawStatus: "withdraw status",
    NoData: "No data available",

    UnderReview: "Under Review",
    Processing: "Processing",
    Completed: "Completed",
    Rejected: "Rejected",
    Failed: "Failed",

    Pending: "Pending",
    Success: "Success",
    NoMore: "No more",
    PleaseWait: "Please wait...",
    PleaseSelect: "Please select",
    Date: "Date",
    RealAmount: "Real Amount",
    Fee: "Fee",
    Status: "Status",
    Remark: "Remark",
  },

  coinManagement: {
    myGoldenbeans: "My Gold Beans",
    Withdraw: "Withdraw",
    ExchangeGoldCoins: "Exchange",
    HostInformation: "Host Information",
    WithdrawalCurrency: "Withdrawal Currency",
    SelectWithdrawalCurrency: "Please select withdrawal currency",
    FiatCurrency: "Fiat Currency",
    PleaseSelectWithdrawalCurrency: "Please select withdrawal currency",
    tips: "Note：",
    tipsp0: "1. Withdrawal rate: 10,000 gold beans = 0.5 USD",
    tipsp1:
      "2、Withdrawal threshold: 100,000 gold beans, withdrawals can only be made in multiples of 10,000",
    tipsp2:
      "3、Bind a withdrawal account. Due to various payment methods and the lack of fixed documentation in foreign countries, the backend requires multiple types of verification when adding an account as a family head (specific payment methods depend on the current situation).",
    tipsp3: "4、Whether identity verification has been completed",
    tipsp4: "5、Binding a phone number",
    tipsp5:
      "If any of the above steps are incomplete, withdrawal cannot proceed. At this point, the page will prompt the user or guide them to complete the process",
    tipsp6: "① Prompt only",
    tipsp7:
      "② Redirect to the phone number binding page. After completion, return to the previous page.",
    tipsp8:
      "③ Redirect to the identity verification page. After completion, return to the previous page.",
    tipsp9:
      "④ Redirect to the account binding page. After completion, return to the previous page.",

    tipsp10:
      "3、Withdrawals will incur certain transaction fees, which will vary depending on the channel.",

    tipsp11: "1. Exchange rate: 1000 gold beans = 500 gold coins",
    tipsp12:
      "2. Minimum 5000 gold beans for exchange, must be in multiples of 1000",
    tipsp13:
      "3. Successful exchanges cannot be revoked, please exchange carefully",
    num: "Quantity",
    Custom: "Custom",
    PleaseEnter: "Please enter",
    Redeem: "Redeem",
    SelectType: "Select Type",
    GoldBeans: "Gold Beans",
    GoldCoin: "Coin",
    WithdrawalAmount: "Withdrawal Amount",
    PleaseNum: " Enter the number of coins to withdraw",
    All: "All",
    Withdraw: "Withdraw",

    Incomedetails: "Income details",
    Expensedetails: "Expense details",
    Nobeans: "No redeemable gold beans",

    balance: "Balance",

    Record: "Transaction Record",
    //提现记录
    WithdrawalRecord: "Withdrawal Record",
  },

  contactUs: {
    Officialcustomerservice: "Official Customer Service",
    ContactUs: "Contact Us",
    Issueofguild: "Guild Registration Issues",
  },

  myInvitation: {
    MyGoldBeans: "My Gold Beans",
    Share: "Share to Invite More Friends",
    CopyLink: "Copy Link",
    GoldCoinEarnedToday: "Gold Bean Earned Today",
    TotalGoldCoin: "Total Gold Bean Accumulated",
    tips: "Invite and Bind New Users to Recharge Any Amount to Farn a 1% Gold  Bean(Cannot bind after 48 hours ofregistration)",
    tips2: "Cannot bind after 48 hours of registration",
    MyInvitations: "My Invitations",
    BillingDetails: "Billing Details",
    Total: "Total",
    People: "People",
    GoldCoinGiven: "Gold Bean Given",
    GiveGoldCoin: "Give+",
  },

  userMisconduct: {
    title1: "Content Violation I",
    p1: "1.Display or Spread Restricted Content:",
    p2: "Includes sharing pornography, vulgarity, violence, or racist content through Rain Live's private messages, live streams, or other features.",
    p3: "2.Spread Hate Speech:",
    p4: "Prohibits hate speech targeting religion, race, politics, or national identity.",
    p5: "3.Promotion or Recruitment:",
    p6: "Prohibits inviting users to join other applications or platforms through live streams, private messages, or reviewed comments.",
    title2: "Consequences",
    p7: "Accounts, devices, or IP addresses involved in such violations may be banned.",

    title3: "Content Violation II",
    p8: "1.Sharing Private Information:",
    p9: "Prohibits sharing private information such as phone numbers, account IDs, Facebook accounts, or photos via Rain Live's live streams, comments, or private messages.",
    p10: "2.Account Misuse:",
    p11: "Prohibits providing, renting, or selling Rain Live accounts to others.",
    p12: "3.Using Private Information:",
    p13: "Prohibits using or sharing private information (photos, nicknames, etc.) without user consent for personal gain or malicious purposes.",
    title4: "Consequences",
    p14: "Violating users will be permanently banned.",
  },

  landingPage: {
    info1: "Rain Live Circle",
    info2: "Apl Internal Purchase",
    item1: "45K Reviews",
    item2: "Download",
    item3: "Level 3 3+",
    btn: "Download",
    title: "About Rain Live",
    content:
      "Rain Live is a heartwarming online live-streaming app for everyone, including voice, video, entertainment, and games. The platform gathers high-profile hosts and serves as a deep and content-rich live-streaming platform. Intense PK matches, endless events, cool gifts, and an imperial experience await.",
    tips: "Rain Live ranks first on the list of popular free social applications.",
  },

  equityLevel: {
    Experience: "Experience Points",
    Level: "Current Level",
    Berikutnya: "Distance to Next Level",
    title1: "Level Privileges",
    desc1:
      "The higher the level, the more prestigious the icon level, and the easier it is to gain the favor of your favorite host.",
    title2: "How to Upgrade",
    desc2:
      "1、User level is determined by the amount of experience points earned from gift consumption.",
    desc3:
      "2、You can earn experience points by sending gifts daily to level up.",
    desc4:
      "3、Lucky gifts: For every 1 coin spent, you gain 1 experience point.",
    desc5:
      "4、Special effect gifts: For every 1 coin spent, you gain 10 experience points.",
    title3: "Level Privileges",
    desc6:
      "The higher the level, the more prestigious the icon level, and the easier it is to gain the favor of users.",
    title3: "How to Upgrade",
    desc7:
      "1、Host level is determined by the amount of experience points earned from receiving gifts.定",
    desc8:
      "2、You can earn experience points by receiving gifts daily to level up.",

    title6: "User level",
    title7: "Level",
    title8: "Level badge",
    title9: "Host level",
    title10: "Total experience points",

    LevelDescription: "Level description",
  },

  applyJoin: {
    tips1: "Please enter your WhatsApp account",
    title2: "Photo requirements",
    tips2:
      "Please show your face and upper body, and pose with your hands in a cat-like manner",
    tips3:
      "The photo will be taken for the company is review purposes only, andthe authorities will keep it confidential.",
    tips4: "The photo must be of yourself.",
    title3: "Video Requirements",
    tops5: "The video must feature the person themselves.",
    tips6: "The video should be between 10 to 20 seconds in length.",
    status1: "Submit for review",
    status2: "Under review",
    status3: "Review successful",
    status4: "Review failed",
    LiveMode: "Live mode",
    Video: "Video",
    Voice: "Voice",

    MP4: "Please choose an MP4 format video",
    pngOrJpg: "Please upload a PNG or JPG format image",

    UploadingWait: "Uploading, please wait",
    CompleteInformation: "Please complete the information",
  },

  cancelAccount: {
    title: "Apply for Account Deletion",
    tips: "The following information will be cleared and cannot be recovered:",
    p1: "Once the account is deleted, all information will be permanently removed (including followers, fans, etc.), and any purchased premium services will no longer be retained or transferable to other accounts (e.g., VIP, special ID, avatar frame, etc.).",
    p2: "Linked Facebook, Twitter, Apple, and Google accounts will be unlinked. After unlinking, you may re-register.",
    p3: "Information related to your host application will be unlinked, allowing you to bind it to another account. (If you are a live streaming host, your host information can be reverified for live streaming).",
    p4: "Upon account deletion, any remaining gold coins, diamonds, experience points, vehicles, nobles, and other earnings-related data will be cleared. Any resulting loss of benefits will be borne by the person initiating the account deletion.",
    p5: "If you are a guild leader, submitting an account deletion request will automatically dissolve the guild. (Once the guild is dissolved, it cannot be restored even if the deletion request is withdrawn). If you are a guild member, account deletion will automatically remove you from the guild (you may withdraw the deletion request within 15 days to recover).",
    p6: "If you are a family leader, you must disband or leave the family before submitting an account deletion request.",
    p7: "If you are a family member (not a family leader), submitting an account deletion request will immediately remove you from the family (reversing the deletion within the 15-day appeal period will not restore family membership).",
    p8: "After submitting the deletion request, there is a 15-day appeal period. Logging in during this period will automatically cancel the deletion. Once the appeal period expires, the account will be permanently deleted and cannot be recovered. If the account needs to be recovered due to unauthorized or accidental operations, please contact customer support to appeal. (Customer Support WhatsApp: +62 81188011180, or email: rainlive888@gmail.com).",
  },

  Proxy: {
    Hello: "Hello,",
    Welcome: "Welcome to Rain Live!",
    Account: "Account",
    Pleaseenter: "Please enter",
    Password: "Password",
    Login: "Login",
    MyAgent: "My agent",
    Nickname: "Agency nickname",
    CoinBalance: "Agency coin balance",
    TransferRecord: "Transfer record",
    Recharge: "Recharge",
    TransferInformation: "Please fill in transfer information",
    Reset: "Reset",
    RecipientID: "Recipient ID",
    RecipientNickname: "Recipient nickname",
    TransferAmount: "Transfer amount",
    Transfer: "Transfer",
    KindReminder: "Kind reminder",
    DoubleCheck: "Please double-check the information to ensure accuracy",
    SelectAmount: "Please select the amount to top up",
    SelectMonth: "Select month",
    Username: "Username",
    TransferTime: "Transfer time",
    AutoFill: "Auto-fill",
    Rechargeselection: "Recharge selection",
    ProxyCurrency: "Insufficient Agent Coins",
    PaymentAmount: "Payment amount",
    PleaseSelectAmount: "Please select the amount to top up",
  },

  bd: {
    incomeDetail: {
      title: "Income Details",
      lastWeekIncome: "Last Week Income",
      totalIncome: "Total Historical Income",
      guildId: "Guild ID",
      date: "Date",
      thisWeek: "This Week",
      lastWeek: "Last Week",
      beforeLastWeek: "Week Before Last",
      thisMonth: "This Month",
      lastMonth: "Last Month",
      summary: "Summary",
      guildName: "Guild Name",
      guildIncome: "Guild Income",
      effectiveLive: "Effective Live",
      myIncome: "My Income",
      noData: "No Data Available",
      searching: "Searching income data",
      showingSummary: "Showing summary data",
    },
    index: {
      title: "BD",
      guildCount: "Guild Count",
      weekEstimatedIncome: "This Week Estimated Income",
      lastWeekIncome: "Last Week Income",
      inviteCode: "Invitation Code",
      searchPlaceholder: "Please enter Guild ID",
      lastWeek: "Last Week",
      guildName: "Guild Name",
      guildId: "Guild ID",
      weekIncome: "Guild Weekly Income",
      myIncome: "My Income",
      effectiveLive: "Effective Live",
      bindDays: "Binding Days",
      copySuccess: "Invitation code copied",
      enterGuildId: "Please enter Guild ID",
      searchGuild: "Search Guild ID",
      search: "Search",
      summary: "Summary",
      selectWeek: "Select Week",
      loading: "Loading...",
      loadFailed: "Load failed",
      networkError: "Network error, please try again later",
    },
  },

  noble: {
    expireTime: "Expiration time",
    canReceive: "Can receive {coin} coins",
    receive: "Receive Now",
    received: "Already Received",
    becomeNoble: "Activate",
    totalCanGet: "Total can get {price}{totalCoin} coins",
    silver: "Silver",
    gold: "Gold",
    platinum: "Platinum",
    diamond: "Diamond",
    obsidian: "Obsidian",
    privileges: {
      getCoin: "Get Coins",
      avatarFrame: "Avatar Frame",
      medal: "Medal",
      vehicle: "Vehicle",
      purchaseNotification: "Purchase Notification",
      chatBubble: "Chat Bubble",
      colorfulNickname: "Colorful Nickname",
      specialId: "Special ID",
      mystery: "Mystery Person",
      exclusiveService: "Exclusive Service",
      title: "Exclusive Privileges",
      Effect: "Room Entry Effect",
    },
    receiveSuccess: "Received Successfully",
    contactOperation: "Please contact operations to obtain",

    level1Recharge: " Silver VIP / 30 Days",
    level2Recharge: "Gold VIP / 30 Days",
    level3Recharge: "Platinum VIP / 30 Days",
    level4Recharge: "Diamond VIP / 30 Days",
    level5Recharge: "Black VIP / 30 Days",
  },

  bonusActivity: {
    title: "Live Streaming Bonus Activity",
    activityTime: "Activity Period: Apr 7 00:00 - May 4 23:59:59(UTC+8)",
    rewardRules: "Reward Rules",
    reward: "Rewards",
    totalReceived: "Total Received",
    bonus: "Bonus",
    claim: "Claim",
    claimed: "Claimed",
    notAchieved: "Not Achieved",
    duration: "Duration(Hours)",
    target: "Target(Coins)",
    note: "Note: After reaching the target, the bonus can be claimed the next day",
    activityCalendar: "Activity Calendar",
    april: "April",
    may: "May",
    claimSuccess: "Claimed Successfully",
  },

  bonusActivityRule: {
    activityDescription: "Activity Description",
    descriptionContent:
      "In addition to the basic rewards, hosts will receive extra bonuses from Rain Live.",
    activityTime: "Activity Period",
    timeContent1: "April 7, 2025 to May 4, 2025 (UTC+8)",
    timeContent2:
      "At 0:00 (UTC+8) every day, the next day's rewards will be activated",
    claimMethod: "Claim Method",
    claimContent:
      "When the target is achieved on the current day, rewards can be manually claimed the next day.",
    rewardTable: "Reward Table:",
    targetTurnover: "Target Turnover",
    activityReward: "Activity Reward",
  },

  inviteFriends: {
    invitationEventTitle: "Invitation Event",
    inviteAndEarnRewards: "Invite & Earn Rewards",
    eventPeriod: "Event Period: April 7 00:00 - May 4 23:59:59 (UTC+8)",
    invitationRecord: "Invitation Record",
    eventDetails: "Event Details",
    week1DateRange: "Week 1: April 7 - April 13",
    totalInvitedExample: "Total Invited",
    level1RewardText: "Lv.1 Invite 20 people 20000 Coins",
    level2RewardText: "Lv.2 Invite 50 people 50000 Coins",
    level3RewardText: "Lv.3 Invite 100 people 100000 Coins",
    statusClaimed: "Claimed",
    actionClaim: "Claim",
    statusNotAchieved: "Not Achieved",
    topUpRewardsLabel: "Top-Up Rewards:",
    copyInvitationLink: "Copy Invitation Link",
    rewardNote:
      "Note: When the invited user top-ups, you will receive 2% of the corresponding coins as a reward.",
    copySuccess: "Copy Successful",
    claimSuccessExample: "Successfully Claimed 20000 Coins",
    userIDLabel: "User ID",
    userNameLabel: "User Name",
    timeLabel: "Time",
    topUpLabel: "Top-Up",
    eventPurposeTitle: "【Event Purpose】",
    eventPurposeDesc:
      'To thank users for their long-term support and love for Rain Live, the platform is launching the "Invite Friends & Enjoy Multiple Rewards" event. We sincerely invite you and your friends to enjoy an exciting live streaming experience together!',
    eventDurationTitle: "【Event Duration】",
    eventDateRange: "April 7, 2025 – May 2025",
    eventCycleDesc:
      "A total of 4 weeks, with new rewards starting every Monday at 00:00 (UTC+8).",
    rewardRulesTitle: "【Reward Rules】",
    rewardRulesDesc1:
      "In addition to this event's rewards, you will continue to enjoy the original invitation bonus:",
    rewardRulesDesc2:
      "2% of the invited user's top-up coins will be rewarded to the inviter.",
    importantNotesTitle: "【Important Notes】",
    importantNotesDesc:
      "⚠️ Using fake accounts, bot registrations, or other malicious actions to obtain rewards is strictly prohibited. If detected, all rewards will be revoked immediately, and account restrictions may be applied.",
  },
  bonusPoints: {
    activityTime: "Event Time：",
    resetTime: "Resets daily at 0:00 (UTC+8)",
    pointsReward: "Points Reward",
    coinsReward: "Coins Reward",
    participationTimes: "Participation Count:{times}times",
    points: "Points",
    exchange: "Redeem",
    pointsMall: "Points Mall",
    note: "Note",
    rule1: "1.Points are earned by completing daily tasks.",
    rule2: "2.Rewards in the points mall change irregularly.",
    rule3: "3.Redeemed points are non-refundable. Redeem carefully.",
    coins: "Gold Coin",
    claim: "Claim",
    claimed: "Claimed",
    notAchieved: "Not Achieved",
    reach: "reach",
  },
  gameRanking: {
    notRanked: "Not Ranked",
    distanceToRank: "{points} points away from rank 50",
    distanceToBeforeRank: "{points} points away from rank {rankId}",
    rank1: "You are already in first place",
    rules: {
      pointsStats: {
        title: "Rules for Points Statistics",
        conversion:
          "1. Points Conversion Standard：1 gold coin is equivalent to 1 point in the event, and participants' points will be calculated directly based on the number of gold coins.",
        timeRange:
          "2. Statistics Time Range：The daily points statistics period is 00:00 to 23:59 (UTC+8 Time Zone), and gold coin data beyond this time period will be included in the next day's statistics.",
      },
      ranking: {
        title: "Ranking and Reward Rules",
        basis:
          "3. Ranking Basis：The system will rank participants in descending order based on their daily final points (i.e., the total number of gold coins that day) to determine the daily ranking.",
        rewards: "4. Reward Settings：",
        reward1: "Rank 1: Reward of 250,000 gold coins",
        reward2: "Rank 2: Reward of 150,000 gold coins",
        reward3: "Rank 3: Reward of 100,000 gold coins",
        reward4: "Rank 4: Reward of 50,000 gold coins",
        reward5: "Rank 5: Reward of 50,000 gold coins",
      },
      distribution: {
        title: "Reward Distribution Rules",
        description:
          "The rewards corresponding to the daily ranking will be distributed uniformly on the next day. Participants can log in to the event page or their personal account on the next day to check the reward receipt status.",
      },
      pointsCalculation: {
        description:
          "A minimum Game turnover of 5,000,000 is required to be eligible for the event rewards.",
      },
      helpReward: {
        description:
          "Help Reward: If the corresponding requirements are met but the ranking reward is not claimed, the help reward will be obtained.",
      },
      turnoverRewards: {
        title: "Turnover Reward Rules",
        turnover: "Turnover",
        reward: "Reward",
        turnover1M: "1,000,000",
        reward10K: "10,000 Gold Coins",
        turnover3M: "3,000,000",
        reward30K: "30,000 Gold Coins",
        turnover5M: "5,000,000",
        reward50K: "50,000 Gold Coins",
      },
      violation: {
        title: "Violation and Penalty Rules",
        description:
          "During the event, participants are strictly prohibited from using system vulnerabilities, plug-ins, or any other means to cheat by brushing points (gold coins). If found:",
        penalty1:
          "5. First-time violators will have their qualification for the day's reward revoked;",
        penalty2:
          "6. Violators with serious circumstances or repeated violations will be directly banned from participating in this event and subsequent related events, and the participation right will not be restored.",
      },
    },
  },
  luckyAnchorRanking: {
    today: "Today",
    yesterday: "Yesterday",
    notRanked: "Not ranked",
    distanceToRank: "Need {points} more lucky beans to reach top 50",
    distanceToBeforeRank:
      "Need {points} more lucky beans to reach rank {rankId}",
    rank1: "You are already rank 1",
    rules: {
      activity: {
        title: "Activity Description",
        description:
          "Count the daily lucky bean income of anchors and rank them based on this income.",
      },
      ranking: {
        title: "Ranking Rewards",
        rank: "Rank",
        reward: "Reward Beans",
        decoration: "Decoration",
        frameAndBubble: "Avatar Frame + Bubble",
        frameOnly: "Avatar Frame",
        requirement:
          "Minimum requirement for ranking rewards: 150,000 lucky bean income.",
      },
      helpReward: {
        title: "Support Rewards",
        description:
          "Users who do not receive ranking rewards can also get lucky bean income target rewards.",
        target: "Target",
        reward: "Reward",
      },
      distribution: {
        title: "Reward Distribution",
        description: "Rewards will be distributed the next day.",
      },
      statistics: {
        title: "Statistics Description",
        description: "The statistics are based on lucky bean income.",
      },
    },
  },

  // Red Envelope Rain Activity
  redEnvelopeRain: {
    countdownTitle: "Countdown to Grab Coins",
    startNow: "Start Now",
    rules: "Rules",
    timeSlotPrize: "Prize draw time",
    winningDetails: "Winning Details",
    activityRules: "Activity Rules",
    congratulations: "You Won!",
    sorryNoWin: "Sorry, you didn't win!",
    coin: "Coins",
    rulesContent: {
      rule1: "1.Activity Time: September 26 ~ October 15",
      rule2:
        "2.Activity Rules: Before each red envelope opens, complete 3 messages in the live streaming room to receive the red envelope.",
      rule3:
        "3.Every day from 20:00 to 00:40, red envelopes can be claimed every 20 minutes.",
      rule4: "4.You can participate repeatedly in different time slots",
      rule5:
        "5.The coins you receive will be distributed to your account in real-time",
    },
    timeStatus: {
      inProgress: "In Progress",
      notStarted: "Not Started",
      finished: "Finished",
    },
    chatRequirement:
      "Send 3 messages in live room to claim, current messages: {count}",
  },

  // Guild Activity
  guildActivity: {
    activityRules: "Activity Rules",
    rulesContent: {
      activityTime: "Activity Time: Starting September 29",
      rankingRewards: "Ranking Rewards",
      requirements: "Requirements",
      rewardDistribution: "Reward Distribution",
      rewardList: {
        first: "1st Place: 1,000,000 Gold Beans",
        second: "2nd Place: 500,000 Gold Beans",
        thirdToFifth: "3rd-5th Place: 250,000 Gold Beans",
      },
      requirementText:
        "Guild hosts must complete at least 30 live streams per week. Each host's daily live stream over 2 hours counts as one session",
      distributionText: "Rewards will be distributed in the second week",
    },
  },

  // Charm/Consumption Ranking
  charmRanking: {
    charmRanking: "Charm Ranking",
    consumptionRanking: "Consumption Ranking",
    dailyRanking: "Daily Ranking",
    weeklyRanking: "Weekly Ranking",
    userNickname: "User Nickname",
    distanceToPrevious: "Previous",
    noRankingData: "No Ranking Data",
    requestFailed: "Request Failed",
  },

  // Invite Activity
  inviteActivity: {
    title: "Invite 3 People Get Rewards",
    rule: "Rule",
    alreadyJoined: "Already Joined",
    inviteImmediately: "Invite Now",
    callNumber: "Invite",
    myRewards: "My Rewards",
    claim: "Claim",
    claimed: "Claimed",
    people: "People",
    inviteFriends: "Invite Friends",
    processTitle: "Invitation Process:",
    step1: "1.Send link to friends",
    step2: "2.Friends download and register",
    step3: "3.Get free coins",
    rulesTitle: "Invitation Rules",
    rulesContent: {
      rule1: "When 3 people are invited, you can claim 16666 gold beans",
      rule2:
        "When 25 people are invited, you can claim another 36666 gold beans",
      rule3:
        "When 100 people are invited, you can claim another 88888 gold beans. Total claimable: 142220 gold beans.",
      rule4: "Rewards are manually claimed on the activity page.",
      rule5:
        "Malicious manipulation of invitation numbers is strictly prohibited. Account suspension will be enforced if detected",
    },
    close: "Close",
    inviteFeatureComingSoon: "Invite feature coming soon",
    rewardReceived: "Successfully received {amount} coins!",
  },

  // Gift Gold Coins Page
  giftGoldCoins: {
    maxGiftableCoins: "Maximum Giftable Coins",
    giftAmount: "Gift Coin Amount",
    customAmount: "Custom Gift Coin Amount",
    enterAmount: "Enter amount",
    quantity: "Quantity",
    giftToOtherAccounts: "Gift to Other Accounts",
    exceedMaxAmount: "Amount cannot exceed maximum giftable amount",
    amountSet: "Amount set successfully",
    invalidAmount: "Please enter a valid amount",
    selectValidAmount: "Please select a valid amount",
    confirmTitle: "Confirm Gift",
    confirmMessage: "Are you sure you want to gift {amount} coins?",
    giftSuccess: "Gift Successful",
    giftId: "Gift ID",
    enterGiftId: "Please enter ID",
    pleaseEnterGiftId: "Please enter gift ID",
    giftCompleted: "Gift completed!",
    giftedToId: "Gifted to ID",
    networkError: "Network error, please try again later",
    confirm: "Confirm",
  },

  // Decoration Shop
  shop: {
    headerTitle: "Personal Decoration",
    back: "Back",
    shoppingBag: "Shopping Bag",
    loading: "Loading...",
    noProducts: "No Products",
    unnamedProduct: "Unnamed Product",
    day: "Day",
    myCoins: "My Coins",
    exchangeNow: "Exchange Now",
    notSelected: "Not Selected",
    loginExpired: "Login expired, please login again",
    categoryNotExists: "Category does not exist",
    loadFailed: "Load Failed",
    loadFailedRetry: "Load failed, please try again",
    pleaseSelectProduct: "Please select a product first",
    productNotExists: "Product does not exist",
    insufficientCoins: "Insufficient coins, need {amount} coins",
    exchangeSuccess: "Exchange Successful",
    exchangeFailed: "Exchange Failed",
    categories: {
      hot: "Hot",
      avatarFrame: "Frame",
      entryEffect: "Entry Effect",
      chatBubble: "Bubble",
      mount: "Vehicle",
    },
    recharge: "Recharge >",
    validityPeriod: "Validity Period:",
    myCoinsLabel: "My Coins:",
  },
  myDecoration: {
    headerTitle: "My Decoration",
    back: "Back",
    noWearingDecoration: "No selected decoration",
    loading: "Loading...",
    noDecoration: "No Decoration",
    unnamedDecoration: "Unnamed Decoration",
    permanent: "Permanent",
    wearing: "Wearing",
    pleaseSelectDecoration: "Please Select Decoration",
    removeDecoration: "Remove Decoration",
    wearNow: "Wear Now",
    pleaseSelectDecorationFirst: "Please select a decoration first",
    decorationNotExists: "Decoration does not exist",
    loginExpired: "Login expired, please login again",
    loadFailed: "Load Failed",
    loadFailedRetry: "Load failed, please try again",
    wearSuccess: "Wear Successful",
    wearFailed: "Wear Failed",
    categories: {
      avatarFrame: "Frame",
      entryEffect: "Entry Effect",
      chatBubble: "Bubble",
      mount: "Vehicle",
    },
  },
  // Christmas Activity/Lucky Star Activity
  christmasActivity: {
    dailyLuckyStar: "Daily Lucky Star",
    weeklyLuckyStar: "Weekly Lucky Star",
    startTime: "Start time:",
    obtainedCount: "Obtained Count",
    moreChance: "More gifts, more chances",
    participated: "Met",
    notParticipated: "Unmet",
    historyRecord: "History Record",
    myRecord: "My Record",
    noRecord: "No Record",
    loading: "Loading...",
    noMore: "No More",
    coin: "Coins",
    goldCoin: "Golden Beans",
    unit: "pcs",
    notWon: "Not Won",
    conditionNotMet: "Condition not met",
    claimSuccess: "Claim successful",
    getRecordFailed: "Failed to get record",
    rules: {
      title: "Activity Rules",
      rule1: "Daily Lucky Star",
      rule2: "Daily Lucky Star event, all users can participate.",
      rule3:
        "When giving corresponding gifts to hosts, the number of gifts will be accumulated. When the number of gifts given meets the requirements, users can participate in the red packet opening, and each opening will have a lucky user receiving coin rewards.",
      rule4: "The more gifts given, the higher the chance of winning",
      rule5: "Weekly Lucky Star",
      rule6: "Weekly Lucky Star event, all hosts can participate.",
      rule7:
        "When receiving corresponding gifts from users, the number of gifts will be accumulated. When the number of gifts received meets the requirements, hosts can participate in the Weekly Lucky Star red packet opening, and each opening will have a lucky host receiving rewards.",
      rule8: "The more gifts received, the higher the chance of winning",
      rule9: "Other Notes",
      rule10: "This event is a big welfare appreciation program.",
      rule11: "Only applies to accumulation when giving gifts to other hosts.",
      rule12: "Strictly prohibited to use bugs/exploits to gain benefits.",
      rule13:
        "Rewards for each time period will be automatically distributed. You can check the winning records to understand the winning situation.",
    },
  },

  // Fortune Star Points Ranking Activity
  fortuneStarActivity: {
    points: "Point",
    pointsRanking: "Points Ranking",
    currentRoundPoints: "This",
    lastRoundPoints: "Last",
    defaultUserName: "User Name",
    noData: "No Data",
    activityRules: "Rules",
    historyRecord: "History",
    earnedPoints: "Earned Points",
    participated: "Participated",
    notParticipated: "Not Met",
    myRecord: "My Record",
    userId: "ID",
    userNickname: "Name",
    sessionTime: "Time",
    winningStatus: "Winning Status",
    won: "Won",
    notWon: "Not Won",
    rules: {
      rule1:
        "During the event, users can earn points by sending specified gifts",
      rule2:
        "Points are accumulated in real-time, check the current points ranking",
      rule3:
        "After the event ends, top-ranked users will receive generous rewards",
      rule4: "Cheating is strictly prohibited, violators will be disqualified",
      rule5: "The platform reserves the right of final interpretation",
    },
  },

  // Blind Box Activity
  blindBox: {
    title: "Gameplay Introduction",
    ruleTitle: "Gameplay Introduction",
    rule1:
      "Every {price} gold coins unlock one {text}. Upon opening, you'll get random gifts that are automatically added to your backpack.",
    rule2:
      "Gifts obtained can be sent from your backpack to your desired streamer, who will receive the corresponding gold beans in return.",
    rewardTip: "Reward Tips",
    probabilityDesc: "The specific probability is as follows:",
    prize: "Prize",
    probability: "Probability",
    value: "Value",
  },
  pcOfficial: {
    navHome: "Home",
    navLive: "Live",
    navGameHall: "Game Hall",
    received: "received",
    heroTagline: "A Leading Web4 Entertainment Platform",
    heroTaglineSub:
      "24/7 real-time interaction with top hosts and premium blockchain gaming. Powered by decentralization for instant rewards and fair play.",
    downloadNow: "Download Now",
    giftCoin: "EX Coin",
    giftAvatarFrame: "Avatar Frame",
    bottomDownloadAndroidApk: "Android APK",
    recommendTitle: "Featured Hosts",
    recommendSub: "Interact with thousands of top hosts in real time and enjoy P2E gaming",
    hotGamingTitle: "Hot Gaming",
    hotGamingSub: "Real players, real rankings. Will you be the next legend?",
    casinoTitle: "Casino",
    casinoDesc1: "Join live dealers for Baccarat,",
    casinoDesc2: "Roulette, and Blackjack in HD",
    slotsTitle: "Slots",
    slotsDesc: "Spin through premium slot games with 98.5% RTP",
    gamingTitle: "Gaming",
    gamingDesc: "Beyond the reels, dive into multiplayer skill games",
    whyTitle: "Why Rain Live",
    whyItem1Title: "Fair & Just",
    whyItem1Desc: "Audited RNG ensures provably fair gameplay",
    whyItem2Title: "Instant Payout",
    whyItem2Desc: "Fast withdrawals with instant settlement",
    whyItem3Title: "Anonymous & Private",
    whyItem3Desc: "100% private with no personal information required",
    whyItem4Title: "Decentralized",
    whyItem4Desc: "Secure and transparent on-chain gaming",
    terms: "Terms of Service",
    privacy: "Privacy Policy",
    navRecharge: "Recharge",
    rechargeAccountTitle: "Recharge account",
    idLogin: "ID login",
    accountIdLabel: "Account ID:",
    accountIdPlaceholder: "Enter account ID",
    confirm: "Confirm",
    defaultUserName: "Username",
    userIdWithValue: "ID:{id}",
    switchAccount: "Switch account",
    rechargeQuantityTitle: "Amount",
    goToPay: "Continue to pay",
    topUpAmountTitle: "Top-up amount",
    pay: "Pay",
    channelDefault: "Channel",
    toastInvalidAccountId: "Please enter a valid account ID",
    toastNoTokenAfterLogin: "Login succeeded but token was not returned",
    toastLoginFailed: "Login failed",
    toastCoinPackagesFailed: "Failed to load coin packages",
    toastPayChannelsFailed: "Failed to load payment channels",
    toastOrderParamsMissing: "Missing order parameters",
    toastNoPayUrl: "Payment URL not found",
    toastCreateOrderFailed: "Failed to create payment order",
    rainLiveRecharge: "Rain Live Recharge",
    selectCountryTitle: "Select country / region",
    selectChannelTitle: "Select payment method",
    rechargeLoading: "Loading...",
    rechargePackagesEmpty: "No recharge packages available",
    rechargeLoginHint: "Please sign in with your ID first",
  },
};
